import { render, staticRenderFns } from "./DocMain.vue?vue&type=template&id=07b82b78&"
import script from "./DocMain.vue?vue&type=script&lang=js&"
export * from "./DocMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports